const types = {
  Login: 'Login',
  SetUserInfo: 'SetUserInfo'
}

export default types
